import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as yup from 'yup';

const useAccountUnlockResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const headingRef = useRef(null);

  const data = location?.state?.data || '';
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const schema = yup.object({
    newPassword: yup
      .string()
      .required('New Password is required')
      .min(8, 'Password must be at least 8 characters long')
      .matches(/[a-z]/, 'Password must contain at least 1 lowercase letter')
      .matches(/[A-Z]/, 'Password must contain at least 1 uppercase letter')
      .matches(/[0-9]/, 'Password must contain at least 1 number')
      .matches(
        /[~`!@#$%^&*()_\-+={[}\]|\\:;"'<,>.?/]/,
        'Password must contain at least 1 special character',
      ),

    confirmPassword: yup
      .string()
      .required('Confirm Password is required')
      .oneOf([yup.ref('newPassword')], 'Passwords must match'),
  });
  const unlockAccount = (values) => {
    navigate('/member/account-unlock-success', {
      state: {
        data: data,
        newPassword: values.newPassword,
        forcePassword: true,
      },
    });
  };
  useEffect(() => {
    if (headingRef.current) {
      headingRef.current.focus();
    }
  }, []);
  return {
    schema,
    showPassword,
    setShowPassword,
    showConfirmPassword,
    setShowConfirmPassword,
    unlockAccount,
    headingRef,
  };
};

export default useAccountUnlockResetPassword;
